var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsignment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.7111C4.5 8.10998 4.5 7.80941 4.58582 7.52598C4.67163 7.24255 4.83835 6.99247 5.1718 6.4923L5.31253 6.2812C5.89382 5.40927 6.18447 4.9733 6.62665 4.73665C7.06884 4.5 7.5928 4.5 8.64074 4.5H15.3593C16.4072 4.5 16.9312 4.5 17.3733 4.73665C17.8155 4.9733 18.1062 5.40927 18.6875 6.2812L18.8282 6.4923C19.1616 6.99247 19.3284 7.24255 19.4142 7.52598C19.5 7.80941 19.5 8.10998 19.5 8.7111V15.5C19.5 17.3856 19.5 18.3284 18.9142 18.9142C18.3284 19.5 17.3856 19.5 15.5 19.5H8.5C6.61438 19.5 5.67157 19.5 5.08579 18.9142C4.5 18.3284 4.5 17.3856 4.5 15.5V8.7111Z",
    stroke: "#657B90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H19.5",
    stroke: "#657B90",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.65C9.5 9.56716 9.56716 9.5 9.65 9.5H14.35C14.4328 9.5 14.5 9.56716 14.5 9.65V13.7052C14.5 14.055 14.1184 14.271 13.8185 14.0911L12.1286 13.0772C12.0495 13.0297 11.9505 13.0297 11.8714 13.0772L10.1815 14.0911C9.88159 14.271 9.5 14.055 9.5 13.7052V9.65Z",
    stroke: "#657B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsignment);
export default __webpack_public_path__ + "static/media/consignment.27000311c438bf7774c9cb46e6f57b22.svg";
export { ForwardRef as ReactComponent };